_ = require 'underscore'
NewPowerUps = require 'app/scripts/data/new-power-ups'

latestDate = _.chain(NewPowerUps).values().max().value()

module.exports =
  if latestDate > Date.now()
    "NewPowerUps_#{ latestDate.toISOString().substr(0, 10) }"
  else
    undefined
